export default __webpack_public_path__ + "static/Hummourr-1b5e773fbb9bcf456316910652a1d792.jpg";